const features = [
  {
    id: 1,
    // image: "/images/wallets/EXPERIENCES.svg",
    image: "/images/wallets/GAMIFIED.svg",
    title: "Gamified Experiences and Education",
    description: "Games for good to inspire action for real world impact.",
    icon: "code",
    bgColor: "bg-accent",
    iconColor: "text-purple-600",
    buttonText: "FIND OUT MORE",
    link: "/our-world-of-impact",
  },
  {
    id: 2,
    // image: "/images/wallets/COLLABORATIONS.svg",
    image: "/images/wallets/CAMPAIGNS.svg",
    title: "Collaborative Impact Art Campaigns",
    description: "Campaigns to engage and gain support for impact goals.",
    icon: "lightbulb",
    bgColor: "bg-accent",
    iconColor: "text-blue-600",
    buttonText: "FIND OUT MORE",
    link: "/art-for-impact-campaign",
  },
  {
    id: 3,
    // image: "/images/wallets/SHOWCASES.svg",
    image: "/images/wallets/IMPACT SHOP.svg",
    title: "Products that Save the World",
    description: "Shop with purpose. Every purchase has a positive impact.",
    icon: "check-circle",
    bgColor: "bg-accent",
    iconColor: "text-yellow-600",
    buttonText: "FIND OUT MORE",
    link: "/impact-shop",
  },
];
export { features };

const features2 = [
  {
    id: 1,
    // image: "/images/wallets/EXPERIENCES.svg",
    image: "/images/wallets/GAMIFIED.svg",
    title: "World of Impact",
    description: "Games for good to inspire action for real world impact.",
    icon: "code",
    bgColor: "bg-accent",
    iconColor: "text-purple-600",
    buttonText: "FIND OUT MORE",
    link: "/our-world-of-impact",
  },
  {
    id: 2,
    // image: "/images/wallets/COLLABORATIONS.svg",
    image: "/images/wallets/CAMPAIGNS.svg",
    title: "Art for Impact",
    description: "Campaigns to engage and gain support for impact goals.",
    icon: "lightbulb",
    bgColor: "bg-accent",
    iconColor: "text-blue-600",
    buttonText: "FIND OUT MORE",
    link: "/art-for-impact-campaign",
  },
  {
    id: 3,
    // image: "/images/wallets/SHOWCASES.svg",
    image: "/images/wallets/IMPACT SHOP.svg",
    title: "Support Your Impact",
    description: "Amplify Your Voice. Mobilise Action.",
    icon: "check-circle",
    bgColor: "bg-accent",
    iconColor: "text-yellow-600",
    buttonText: "FIND OUT MORE",
    link: "/impact-shop",
  },
];
export { features2 };
